import { api } from "../api";

export interface DashboardStats {
  total_users: number;
  total_students: number;
  total_trainers: number;
  total_teachers: number;
  total_managers: number;
  total_centers: number;
  total_classes: number;
  total_sessions: number;
}

export async function getDashboardStats(): Promise<DashboardStats> {
  return api.get<DashboardStats>("/statistics");
}
